import { render, staticRenderFns } from "./ManageConsultant.vue?vue&type=template&id=00fc7810&scoped=true&"
import script from "./ManageConsultant.vue?vue&type=script&lang=js&"
export * from "./ManageConsultant.vue?vue&type=script&lang=js&"
import style0 from "./ManageConsultant.vue?vue&type=style&index=0&id=00fc7810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc7810",
  null
  
)

export default component.exports